module.exports = __webpack_public_path__ + "media/images/athletes/3408-e8497ce978160a480e67475b47583b10.png";